import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Accommodation } from 'models';
import { AccommodationService } from 'services';

@Injectable({
    providedIn: 'root'
})
export class AccommodationsResolver implements Resolve<Accommodation[]> {
    constructor(private accommodationService: AccommodationService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Accommodation[]> {
        return this.accommodationService.getAll();
    }
}
